import React from "react";
import { useAppContext } from "../helpers/account-context";
import FilterOptions from "./Search/FilterOptions";
import SearchForm from './SearchForm'
import RegionsOptions from "./Search/RegionsOption";

// https://stackoverflow.com/questions/49671434/is-there-any-way-to-customize-googles-auto-complete-address-result
// https://developers.google.com/maps/documentation/javascript/examples/geocoding-place-id

// https://developers.google.com/maps/documentation/places/web-service/autocomplete#maps_http_places_autocomplete_fr-rb

const SearchInner = (props) => {
  const { initedData } = useAppContext()
  const {
    filters,
    onChangeSetting,
    onChangeFilters
  } = props;

  // https://codepen.io/smithsuth/pen/VvYzZP
  return (
      <div
        className={`cbmap-search-inner ${
          props.isOpen ? "cbmap-visible" : "cbmap-hidden"
        }`}
      >
        <SearchForm
          {...props}
          initedData={initedData}
          enabledFilterAll={true}
        />  
        {
          initedData.enabledRegions && initedData.enabledRegions.length > 0 &&  <RegionsOptions
          {...props}
          initedData={initedData}
          onChangeFilters={onChangeFilters}
        />  
        }
          
        <FilterOptions
          onChangeSetting={onChangeSetting}
          filters={filters}
        />          
      </div>

  );
};

export default SearchInner;
